import { createAction } from 'redux-actions'
import { urlProvinciasPymes, urlparametrosConstruccion, urlgetCoberturas, urlMaxUbicaciones, urlGetGirosNegocio, urlGetGirosNegocioPymesDiners } from "../../constants/urls";
import { useSelector } from 'react-redux';

export const hasError = createAction('DATA_PYMES_HAS_ERROR');
export const isLoading = createAction('DATA_PYMES_IS_LOADING');
export const provincias = createAction('SET_PROVINCIAS_PYMES');
export const limites = createAction('SET_LIMITES_PYMES');
export const tiposConstruccion = createAction('SET_TIPO_CONSTRUCCION_PYMES');
export const coberturas = createAction('SET_COBERTURAS_PYMES');
export const maxCoberturas = createAction('SET_MAXIMOS_COBERTURAS_PYMES');
export const girosNegocio = createAction('SET_GIROS_NEGOCIO_PYMES');
export const idGiro = createAction('SET_ID_GIRO');
export const coberturasGenerales = createAction('SET_COBERTURAS_GENERALES_PYMES');
export const coberturasGeneralesEE = createAction('SET_COBERTURAS_GENERALES_PYMES_EE');
export const coberturasGeneralesVC = createAction('SET_COBERTURAS_GENERALES_PYMES_VC');



export const ProvinciasPymesFetch = (codProducto = null) => async (dispatch, getState) => {
  const state = getState();
  const date = state.dataPymes.date;
  const now = new Date();
  if (date && date !== '' && now - date < 2 * 60 * 1000) {
   // return;
  }
  dispatch(isLoading());
  await fetch(urlProvinciasPymes)
    .then(response => response.json())
    .then(dato => {

      const { transaccion, provincias: prov } = dato;
      if (transaccion) {
        let data = []
        prov.forEach(({ id, provNombre, provCodigoCore, paiCodigoCore }) => data.push({ id, name: provNombre, provCodigoCore, paiCodigoCore }));
        dispatch(provincias(data));
      } else {
        dispatch(hasError('Error al devolver datos, provincias'))
        return
      }
    })
    .catch((e) => {
      console.error(e)
      dispatch(hasError('Error al consultar servicio, provincias'));
      return
    });
  dispatch(isLoading());
  const { cliCodigoCore } = state.datosUsuarios.dataUsuario
    await fetch(`${urlparametrosConstruccion}${cliCodigoCore}&codProducto=${codProducto}`)
    .then(response => response.json())
    .then(dato => {
        const { transaccion, tiposConstruccion: tcon, limites: limit } = dato;
      if (transaccion) {
        let data = []
        tcon.forEach(({ codigo: id, descripcion: name }) => data.push({ id, name }));
        dispatch(tiposConstruccion(data))
        dispatch(limites(limit))
      } else {
        hasError('Error al consultar datos, parametros Contruccion')
        return
      }
    })
    .catch((e) => {
      dispatch(hasError('Error al consultar servicio, parametros Contruccion'));
      return
    });


};
export const CoberturasPymesFetch = ({ giroNegocio }) => async (dispatch, getState) => {

  const state = getState()


  const { cliCodigoCore } = state.datosUsuarios.dataUsuario




  let url = urlgetCoberturas.replace('{{giroNegocio}}', giroNegocio)

  url = url.replace('{{idBroker}}', cliCodigoCore)

  console.log('mi nueva url es: ', url)



  await fetch(url)
    .then(response => response.json())
    .then(dato => {



      const { transaccion, coberturas: cob } = dato;
      if (transaccion) dispatch(coberturas(cob))
      else hasError('Error al consultar datos, Coberturas')

    })
    .catch((e) => {
      dispatch(hasError('Error al consultar servicio, Coberturas'));
    });


};

export const FetchGirosNegocios = () => async (dispatch, getState) => {
  // const state = getState();
  // const giros = state.dataPymes.girosNegocio;
  // if (giros.length > 0) {
  //   return
  // }

  await fetch(urlGetGirosNegocio)
    .then(response => response.json())
    .then(dato => {
      const { transaccion, girosNegocio: giros } = dato;
      if (transaccion) {
        giros.unshift({ giroNombre: "Seleccione una opción", giroCodigo: "", adicional: false })
        dispatch(girosNegocio(giros));
      } else {
        dispatch(hasError('Error al devolver datos, girosNegocio'))
        return
      }
    })
    .catch((e) => {
      dispatch(hasError('Error al consultar servicio, girosNegocio'));
      return
    });
}

export const FetchMaxCoberturas = ({ giroNegocio, codCobertura, idCarrito }) => async (dispatch, getState) => {
  //await fetch(urlProvinciasPymes+giroNegocio)
  const state = getState()


  const { cliCodigoCore } = state.datosUsuarios.dataUsuario

  console.log('MAXIMOS paso', giroNegocio, codCobertura, idCarrito)

  let url = urlMaxUbicaciones.replace('{giroNegocio}', giroNegocio)
  url = url.replace('{codCobertura}', codCobertura)
  url = url.replace('{cliCodigoCore}', cliCodigoCore)
  url = url.replace('{idCarrito}', idCarrito)


  dispatch(idGiro(giroNegocio))

  await fetch(url)
    .then(response => response.json())
    .then(dato => {
      console.log('MAXIMOS', dato)
      const { transaccion, maximos, generales, } = dato;

      let mensajeError='';
      if (transaccion) {
     
        if (generales) {
          dispatch(coberturasGenerales({ [codCobertura]: generales }));

        }
        else {
          dispatch(hasError('Error al devolver datos, coberturasGenerales'))
          
        }

        if (maximos) {
          dispatch(maxCoberturas({ [codCobertura]: maximos }));
        } else {
          dispatch(hasError('Error al devolver datos, maximosCoberturas'))
  
        }
      }
    })
    .catch((e) => {
      console.error(e)
      dispatch(hasError('Error al consultar servicio, maximosCoberturas'));
      return
    });
}

export const FetchGirosNegociosPymesDiners = () => async (dispatch, getState) => {
 
  await fetch(urlGetGirosNegocioPymesDiners)
    .then(response => response.json())
    .then(dato => {
      const { status, data: giros } = dato;
      if (status) {
        giros.unshift({ giroNombre: "Seleccione una opción", giroCodigo: "", adicional: false })
          dispatch(girosNegocio(giros));
      } else {
        dispatch(hasError('Error al devolver datos, girosNegocio'))
        return
      }
    })
    .catch((e) => {
      dispatch(hasError('Error al consultar servicio, girosNegocio'));
      return
    });
}

